import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';

@inject('dictStore', 'accountStore')
@observer
export default class Logout extends Component {

	render() {

		if (!this.props.accountStore.autoLogout) return null;

		const {seconds, alertVisible, countdownHtml} = this.props.accountStore.autoLogout;
		const {getLang} = this.props.dictStore;

		if (alertVisible) {
			return (
				<LogoutContainer>
					<div className="logout-timer">
						<span dangerouslySetInnerHTML={{__html: `${getLang('AUTO_LOGOUT_NOTE')} ` }}></span>
						{` ${countdownHtml.seconds} ${getLang(countdownHtml.html)}`}
					</div>
				</LogoutContainer>
			)
		}

		return false;
  }
}

export class LogoutContainer extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.modal = document.getElementById('logout-timer');
  }

  componentDidMount() {
    this.modal.appendChild(this.el);
  }

  componentWillUnmount() {
    this.modal.removeChild(this.el);
  }
  
  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}


export class Footer extends Component {
	render() {
		return (
			this.props.children
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/logoutTimer/index.jsx